import { sortString, sortNumber, toSearchableString } from 'app/utils';

const TEMPLATE_NAME = 'PAD_MONITORING_PROFESSIONALS';

const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

/**
 *
 * @param {Array} data Array with professionals
 * @param {String} term Searched term
 */
const filterDataSearch = (data, term) => {
  const resultData = {};

  const result = data.filter(item => {
    const Name = item.name ? filterByTerm(item.name, term) : false;
    return filterByTerm(item.name, term) || Name;
  });

  if (sort) {
    result.sort(sort);
  }

  resultData.professionals = result.length > 0 ? result : data.professionals;

  return resultData;
};

const initialState = () => ({
  loading: false,
  data: {
    professionals: []
  },
  filter: {
    term: '',
    data: {
      professionals: []
    }
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      let { professionals: nProfessionals } = filterDataSearch(newData, null);

      return {
        ...state,
        loading: false,
        data: {
          professionals: [...newData]
        },
        filter: {
          ...state.filter,
          data: {
            professionals: [...nProfessionals]
          }
        }
      };
    }
    case `${TEMPLATE_NAME}_SEARCH`: {
      const term = action.payload;

      return {
        ...state,
        filter: {
          term,
          data: filterDataSearch(state.data.professionals, term)
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
